import { render, staticRenderFns } from "./LoaPage3.vue?vue&type=template&id=d562e7b6&"
import script from "./LoaPage3.vue?vue&type=script&lang=js&"
export * from "./LoaPage3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports